import { CONTACT } from "@/data/site";
import { scrollToId } from "@/lib/scroll";
import { LeafMark } from "@/components/LeafMark";

const LINKS = [
  { label: "Collection", href: "#collection" },
  { label: "Our Story", href: "#story" },
  { label: "Brew Guide", href: "#brew-guide" },
  { label: "Contact", href: "#contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/5 bg-stone-950">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-14 md:flex-row">
        <div>
          <div className="flex items-center gap-4">
            <LeafMark className="h-10 w-10 text-amber-600" />
            <p className="font-serif text-4xl tracking-tight text-stone-100">
              Amber <span className="text-amber-500">Brew</span>
            </p>
          </div>
          <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-stone-500">
            Twelve small-batch teas from the gardens of Darjeeling and Assam.
            Garden, fire, and your table — three leaves on amber.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-16">
          <div>
            <p className="mb-5 text-[10px] uppercase tracking-[0.35em] text-stone-500">Explore</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm font-light text-stone-400 transition-colors duration-300 hover:text-amber-500"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-5 text-[10px] uppercase tracking-[0.35em] text-stone-500">Reach us</p>
            <ul className="space-y-3 text-sm font-light text-stone-400">
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${CONTACT.email}`}
                  className="transition-colors duration-300 hover:text-amber-500"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone-link"
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="transition-colors duration-300 hover:text-amber-500"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="text-stone-500">{CONTACT.hours}</li>
            </ul>
          </div>
        </div>
      </div>

      <p
        data-testid="footer-wordmark"
        className="mt-20 select-none text-center font-serif text-[clamp(3rem,12vw,10rem)] leading-none tracking-tight text-hollow-faint"
      >
        AMBER BREW
      </p>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 text-xs font-light text-stone-600 md:flex-row">
        <p>© 2026 Amber Brew Tea Company. All rights reserved.</p>
        <p>{CONTACT.domain}</p>
        <p>Brewed with patience in India.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
